export default function mergeHandlers(...handlers: any[]) {
  return function handler(...args: any[]) {
    handlers.forEach(handler => {
      if (handler) {
        handler(...args);
      }
    });
  };
}
